export enum RED {
  S400 = '#B71515',
  S300 = '#E22726',
  S100 = '#FFF0F0',
}
